// Without a Steam id (Quick Invite sign-in) the link opens the inventory of the signed-in account
export default function inventoryUrl(steamId) {
  const base = steamId
    ? `https://steamcommunity.com/profiles/${steamId}`
    : 'https://steamcommunity.com/my';
  return `${base}/inventory/#pending_gifts`;
}
